import { API_BASE_URL } from "./config";

class StravaService {
  constructor() {
    this.baseUrl = API_BASE_URL.replace(/\/+$/, "");
    this.state = {
      url_status: `${this.baseUrl}/core/strava/status/`,
      url_connect: `${this.baseUrl}/core/strava/connect/?format=json`,
      url_atividades: `${this.baseUrl}/core/strava/atividades/`,
      url_importar: `${this.baseUrl}/core/strava/importar/`,
      url_disconnect: `${this.baseUrl}/core/strava/disconnect/`,
    };
  }

  getHeaders() {
    const token = sessionStorage.getItem("brv-user-token");
    return {
      "Content-Type": "application/json; charset=UTF-8",
      ...(token ? { Authorization: `Token ${token}` } : {}),
    };
  }

  // 1. Obter status da conexão
  async getStatus() {
    const res = await fetch(this.state.url_status, {
      method: "GET",
      headers: this.getHeaders(),
    });
    if (!res.ok) {
      throw new Error(`Erro ao obter status do Strava: ${res.status}`);
    }
    return await res.json();
  }

  // 2. Obter URL de autorização para o popup / redirecionamento
  async getConnectUrl() {
    const res = await fetch(this.state.url_connect, {
      method: "GET",
      headers: this.getHeaders(),
    });
    if (!res.ok) {
      throw new Error(`Erro ao obter URL de conexão do Strava: ${res.status}`);
    }
    const data = await res.json();
    return data.authorization_url || data.url;
  }

  // 3. Listar atividades recentes do atleta
  async getActivities(limit = 15) {
    const url = `${this.state.url_atividades}?limit=${limit}`;
    const res = await fetch(url, {
      method: "GET",
      headers: this.getHeaders(),
    });
    if (!res.ok) {
      throw new Error(`Erro ao buscar atividades do Strava: ${res.status}`);
    }
    return await res.json();
  }

  // 4. Importar métricas da atividade selecionada
  async importarMetrica(payload) {
    const body = typeof payload === "string" ? payload : JSON.stringify(payload);
    const res = await fetch(this.state.url_importar, {
      method: "POST",
      body,
      headers: this.getHeaders(),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(
        errorData.detail || errorData.error || `Erro ao importar atividade: ${res.status}`
      );
    }
    return await res.json();
  }

  // 5. Desconectar conta Strava
  async desconectar() {
    const res = await fetch(this.state.url_disconnect, {
      method: "DELETE",
      headers: this.getHeaders(),
    });
    if (!res.ok) {
      throw new Error(`Erro ao desconectar Strava: ${res.status}`);
    }
    return await res.json().catch(() => ({ success: true }));
  }
}

export const stravaService = new StravaService();
export default StravaService;
